var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 46,
    viewBox: "0 0 54 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 0.5C5.87773 0.50005 5.40085 0.69761 5.04923 1.04923C4.69761 1.40085 4.50005 1.87773 4.5 2.375V34.25H0.75V38H8.25V45.5H12V38H13.875H21.375H28.875H40.125H42V45.5H45.75V38H47.625H53.25V34.25H49.5V6.125C49.5 5.62773 49.3024 5.15085 48.9508 4.79923C48.5991 4.44761 48.1223 4.25005 47.625 4.25H40.125C39.6277 4.25005 39.1509 4.44761 38.7992 4.79923C38.4476 5.15085 38.25 5.62773 38.25 6.125V34.25H30.75V2.375C30.75 1.87773 30.5524 1.40085 30.2008 1.04923C29.8491 0.69761 29.3723 0.50005 28.875 0.5H21.375C20.8777 0.50005 20.4009 0.69761 20.0492 1.04923C19.6976 1.40085 19.5 1.87773 19.5 2.375V8H15.75V2.375C15.75 1.87773 15.5524 1.40085 15.2008 1.04923C14.8491 0.69761 14.3723 0.50005 13.875 0.5H6.375ZM8.25 4.25H12V9.875V34.25H8.25V4.25ZM23.25 4.25H27V34.25H23.25V9.875V4.25ZM42 8H45.75V34.25H42V8ZM15.75 11.75H19.5V34.25H15.75V11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI13);
export default __webpack_public_path__ + "static/media/i13.cc135461908516a5b375557bca4e65c4.svg";
export { ForwardRef as ReactComponent };